import Vue from 'vue'
import App from './App.vue'
import './assets/styles/base/reset.less'
import Element from 'element-ui'

Vue.use(Element)

Vue.config.productionTip = false

// api配置
import rest from './rest'
// 路由配置
import router from './router'
new Vue({
  router,
  rest, // api
  render: (h) => h(App),
}).$mount('#app')
